import { API_AGENCY_INVITATION, GET_ONBOARDING_EMPLOYEE_LIST } from "../../../../../config/Endpoints.js";
import { postApi, postFormDataMultipart } from "../../../../utils/api.ts";
import { accessToken } from "../../../../utils/auth.ts";
import type { ConsultantType } from "./types.ts";

export interface ConsultantInviteInput {
  consultantName: string;
  personalEmail: string;
  region: string;
  pointOfContact: string;
  consultantType: ConsultantType;
}

export function buildConsultantInvitation(input: ConsultantInviteInput): FormData {
  if (input.region !== "INDIA" && input.region !== "US") throw new Error("Select a valid region.");
  if (!/^\d+$/.test(input.pointOfContact) || Number(input.pointOfContact) <= 0) throw new Error("Select a valid point of contact.");
  const body = new FormData();
  body.append("employeeName", input.consultantName.trim());
  body.append("emailId", input.personalEmail.trim());
  body.append("onboardingFor", input.region);
  body.append("contactEmpId", input.pointOfContact);
  body.append("employeeType", "CONSULTANT");
  body.append("consultantType", input.consultantType === "vendor" ? "VENDOR_BASED" : input.region === "INDIA" ? "INDIAN_CONSULTANT" : "DIRECT");
  return body;
}

export function invitationReference(body: unknown): string | null {
  if (!body || typeof body !== "object") return null;
  const response = body as Record<string, unknown>;
  const reference = response.onboardingReferenceId;
  if (typeof reference === "string" && reference.trim()) return reference.trim();
  return response.data ? invitationReference(response.data) : null;
}

export async function inviteConsultant(input: ConsultantInviteInput) {
  const { data } = await postFormDataMultipart<unknown>(GET_ONBOARDING_EMPLOYEE_LIST, accessToken(), buildConsultantInvitation(input));
  return invitationReference(data);
}

export async function inviteAgency(reference: string, contactName: string, email: string, contactEmpId: string) {
  await postApi(API_AGENCY_INVITATION, accessToken(), {
    onboardingReferenceId: reference,
    contactName: contactName.trim(),
    email: email.trim(),
    contactEmpId: Number(contactEmpId),
  });
}
